module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2014-04-07.fb5c6ed5.md";